import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import classnames from 'classnames';
const className = classnames('flex', 'flex-1', 'flex-col', 'justify-center', 'items-center');
interface Props {
  alt: string;
}
const BrandJumbotron = t0 => {
  const $ = _c(2);
  const {
    alt
  } = t0;
  let t1;
  if ($[0] !== alt) {
    t1 = <div className={className}><div><Image src="/images/brands/personly-logo.svg" width={175} height={175} alt={alt} priority={true} /></div></div>;
    $[0] = alt;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default BrandJumbotron;